(() => {
  const variants = document.querySelectorAll('.variations select');
  let m2 = false;
  const buttonPriceElement = document.querySelector(
    '.single_add_to_cart_button .button__price'
  );

  const qty = document.querySelector('.input-text.qty');
  const qtyWrapper = document.querySelector('.quantity__wrapper');
  const tmpQtyWrapper = document.querySelector('.tmp-quantity__wrapper');
  const tmpQty = document.querySelector('.input_tmp-quantity');

  setTimeout(() => {
    const info = document.querySelector('.woocommerce-variation-customInfo');
    if (info) {
      const text = info.textContent;
      if (text === 'm2') {
        const form = document.querySelector('.variations_form.cart');
        const variantType = form.querySelector(
          '.woocommerce-variation-customInfo .woocommerce_custom_field'
        );
        // console.log(variantType.textContent);
        if (variantType.textContent == 'm2') {
          const m2value = document.querySelector(
            '.woocommerce_custom_field_m2'
          ).textContent;
          m2 = m2value;

          const input = tmpQtyWrapper.querySelector('input');
          input.value = m2value;
          input.min = m2value;
          input.step = m2value;

          qtyWrapper.style.position = 'absolute';
          tmpQtyWrapper.style.display = 'block';
        } else {
          qtyWrapper.style.position = 'initial';
          tmpQtyWrapper.style.display = 'none';
        }
      }
    }
  }, 300);

  if (variants.length) {
    variants.forEach((variant) => {
      variant.addEventListener('change', function () {
        setTimeout(() => {
          const form = this.parentNode.parentNode;
          const variantType = form.querySelector(
            '.woocommerce-variation-customInfo .woocommerce_custom_field'
          );
          // console.log(variantType.textContent);
          if (variantType.textContent == 'm2') {
            const m2value = document.querySelector(
              '.woocommerce_custom_field_m2'
            ).textContent;
            const input = tmpQtyWrapper.querySelector('input');
            input.value = m2value;
            input.min = m2value;
            input.step = m2value;

            qtyWrapper.style.position = 'absolute';
            tmpQtyWrapper.style.display = 'block';
          } else {
            qtyWrapper.style.position = 'initial';
            tmpQtyWrapper.style.display = 'none';
          }
        }, 100);
      });
      //   console.log(variantsWrapper.innerHTML);

      tmpQty.addEventListener('keyup', function () {
        const valBox = parseFloat(m2);
        const valm2 = parseFloat(this.value);
        const box = Math.ceil(valm2 / valBox);
        const newVal = Math.ceil(box * valBox);
        // console.log(valBox);
        // console.log(valm2);
        // console.log(box);

        const price = +document.querySelector(
          '.woocommerce-variation-display_price'
        ).textContent;
        if (!isNaN(box)) {
          qty.value = +box;
          // tmpQty.value = newVal;
          if (buttonPriceElement) {
            setPriceInButton();
            // const allPrice = price * +box;
            // const tmpLimit = number_format(allPrice, 2, ',', ' ') + ' zł';
            // buttonPriceElement.innerHTML = isNaN(box) ? '' : ' ' + tmpLimit;
          }
        } else {
          buttonPriceElement.innerHTML = '';
          qty.value = 0;
        }
      });
      tmpQty.addEventListener('focusout', function () {
        const valBox = parseFloat(m2);
        const valm2 = parseFloat(this.value);
        const box = Math.ceil(valm2 / valBox);
        const newVal = box * valBox;
        // console.log(valBox);
        // console.log(valm2);
        // console.log(box);

        const price = +document.querySelector(
          '.woocommerce-variation-display_price'
        ).textContent;
        if (!isNaN(box)) {
          qty.value = +box;
          tmpQty.value = newVal.toFixed(2);
          if (buttonPriceElement) {
            setPriceInButton();
            // const allPrice = price * +box;
            // const tmpLimit = number_format(allPrice, 2, ',', ' ') + ' zł';
            // buttonPriceElement.innerHTML = isNaN(box) ? '' : ' ' + tmpLimit;
          }
        } else {
          buttonPriceElement.innerHTML = '';
          qty.value = 0;
        }
      });
    });
  }

  if (qty) {
    qty.addEventListener('change', function (e) {
      setPriceInButton();
    });
    qty.addEventListener('keyup', function (e) {
      setPriceInButton();
    });
  }

  $('.variations_form').on('woocommerce_variation_select_change', function () {
    setTimeout(() => {
      // const variantsWrapper = document.querySelector('.variations_form.cart');
      // console.log(variantsWrapper);
      // console.log(this.querySelector('.woocommerce_custom_field_m2'));
      m2 = this.querySelector('.woocommerce_custom_field_m2').textContent;
      qty.value = 1;
      setPriceInButton();
      setDescriptionToTabel();
    }, 100);
  });

  setTimeout(() => {
    setPriceInButton();
    setDescriptionToTabel();
  }, 300);

  function setDescriptionToTabel() {
    const description = document.querySelector(
      '.woocommerce-variation-description'
    );
    const wrapper = document.querySelector(
      '.woocommerce-product-attributes.shop_attributes tbody'
    );
    const addedElement = $(wrapper).find(
      '.woocommerce-product-attributes-item__description'
    );
    if (addedElement.length) {
      addedElement.remove();
    }
    if (description) {
      if (description.textContent) {
        let tmp = $(description).html();
        const txt =
          '<tr class="woocommerce-product-attributes-item woocommerce-product-attributes-item__description"><th>Opis wariantu</th><td>' +
          tmp +
          '</td>';
        $(wrapper).append($(txt));
      }
    }
  }

  function setPriceInButton() {
    let price = document.querySelector('.woocommerce-variation-display_price');
    if (price) {
      price = +document.querySelector('.woocommerce-variation-display_price')
        .textContent;
      const allPrice = price * +qty.value;
      const tmpLimit = number_format(allPrice, 2, ',', ' ') + ' PLN';
      buttonPriceElement.innerHTML = isNaN(qty.value) ? '' : ' ' + tmpLimit;
    }
  }
})();

function number_format(number, decimals, dec_point, thousands_sep) {
  // Strip all characters but numerical ones.
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.round(n * k) / k;
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}
